import styled from "styled-components";
import { useGetAssetOperationData } from "./useGetAssetOperationData";
import ListNeu from "../../interface/ListNeu";

const Container = styled.div`
  display: flex;
  width: 50%;
  height: 100rem;
`;

function AssetOperation() {
  const { data, isLoading, isError, error } = useGetAssetOperationData();

  data && console.log("Data", data);

  const headings = [
    { key: "asset", label: "Asset" },
    { key: "counterType", label: "Type" },
    { key: "last12Month", label: "12 Months" },
    { key: "last6Month", label: "6 Months" },
  ];

  if (isLoading) return <div>loading</div>;
  if (isError) return <div>Error: {error.message}</div>;

  return (
    <Container>
      <ListNeu data={data ? data.data : []} headings={headings} />
    </Container>
  );
}

export default AssetOperation;
